<template>
  <explain-rules :rules="explainData"></explain-rules>
</template>

<script>
import explainRules from '@/components/explainRules/explainRules.vue';
import { explainData } from '@/config/explainData';
import wxShare from '@/common/js/wxShare';

export default {
  name: 'explain',
  components: {
    explainRules,
  },
  data() {
    return {
      explainData,
    };
  },
  mounted() {
    wxShare();
  },
};
</script>

<style scoped lang="stylus">
</style>
